module.exports = new __parcel__URL__("card-visa.1a546991.svg").toString();